// see: https://randomuser.me/api/?results=100&inc=name,gender,email,registered

const users = {
  results: [
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Delores',
        last: 'Price',
      },
      email: 'delores.price@example.com',
      registered: {
        date: '2009-04-21T05:05:58.207Z',
        age: 11,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Adem',
        last: 'Sadıklar',
      },
      email: 'adem.sadiklar@example.com',
      registered: {
        date: '2018-05-14T23:39:22.473Z',
        age: 2,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Willard',
        last: 'Franklin',
      },
      email: 'willard.franklin@example.com',
      registered: {
        date: '2008-12-06T05:00:31.098Z',
        age: 12,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Mellisa',
        last: 'Roubos',
      },
      email: 'mellisa.roubos@example.com',
      registered: {
        date: '2019-03-30T06:49:04.551Z',
        age: 1,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Molly',
        last: 'Madland',
      },
      email: 'molly.madland@example.com',
      registered: {
        date: '2012-04-01T22:27:09.194Z',
        age: 8,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Eduardo',
        last: 'Iglesias',
      },
      email: 'eduardo.iglesias@example.com',
      registered: {
        date: '2004-01-16T20:54:05.854Z',
        age: 16,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Tuva',
        last: 'Sævareid',
      },
      email: 'tuva.saevareid@example.com',
      registered: {
        date: '2014-12-31T17:45:37.924Z',
        age: 6,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Edeltraud',
        last: 'Reichenbach',
      },
      email: 'edeltraud.reichenbach@example.com',
      registered: {
        date: '2011-05-14T19:03:35.798Z',
        age: 9,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Fidan',
        last: 'Van Buul',
      },
      email: 'fidan.vanbuul@example.com',
      registered: {
        date: '2012-09-19T18:50:13.897Z',
        age: 8,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Lawrence',
        last: 'Newman',
      },
      email: 'lawrence.newman@example.com',
      registered: {
        date: '2015-04-09T06:35:09.358Z',
        age: 5,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Nella',
        last: 'Niemela',
      },
      email: 'nella.niemela@example.com',
      registered: {
        date: '2014-05-17T05:00:43.559Z',
        age: 6,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Enola',
        last: 'Voshol',
      },
      email: 'enola.voshol@example.com',
      registered: {
        date: '2009-10-15T02:42:13.305Z',
        age: 11,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Maya',
        last: 'Harcourt',
      },
      email: 'maya.harcourt@example.com',
      registered: {
        date: '2002-10-29T18:15:35.996Z',
        age: 18,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Lyna',
        last: 'Berger',
      },
      email: 'lyna.berger@example.com',
      registered: {
        date: '2014-09-29T10:32:17.302Z',
        age: 6,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Ana',
        last: 'Black',
      },
      email: 'ana.black@example.com',
      registered: {
        date: '2003-08-20T11:27:30.683Z',
        age: 17,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Vivaldo',
        last: 'Peixoto',
      },
      email: 'vivaldo.peixoto@example.com',
      registered: {
        date: '2011-08-13T02:59:24.385Z',
        age: 9,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'John',
        last: 'Martin',
      },
      email: 'john.martin@example.com',
      registered: {
        date: '2006-04-14T03:10:22.274Z',
        age: 14,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Tracey',
        last: 'Duncan',
      },
      email: 'tracey.duncan@example.com',
      registered: {
        date: '2011-01-06T21:37:40.855Z',
        age: 9,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Scott',
        last: 'Peterson',
      },
      email: 'scott.peterson@example.com',
      registered: {
        date: '2013-05-05T23:50:59.192Z',
        age: 7,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Jeremy',
        last: 'Liu',
      },
      email: 'jeremy.liu@example.com',
      registered: {
        date: '2006-11-15T03:40:46.037Z',
        age: 14,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Célia',
        last: 'Schmitt',
      },
      email: 'celia.schmitt@example.com',
      registered: {
        date: '2015-11-30T08:00:09.165Z',
        age: 5,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Evelyn',
        last: 'Li',
      },
      email: 'evelyn.li@example.com',
      registered: {
        date: '2013-11-27T02:45:43.740Z',
        age: 7,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Faustino',
        last: 'Ribeiro',
      },
      email: 'faustino.ribeiro@example.com',
      registered: {
        date: '2002-05-07T03:26:09.406Z',
        age: 18,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Victor',
        last: 'Jensen',
      },
      email: 'victor.jensen@example.com',
      registered: {
        date: '2014-02-09T22:32:15.304Z',
        age: 6,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Greta',
        last: 'Dörner',
      },
      email: 'greta.dorner@example.com',
      registered: {
        date: '2013-09-27T14:09:40.335Z',
        age: 7,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Susanne',
        last: 'Price',
      },
      email: 'susanne.price@example.com',
      registered: {
        date: '2012-12-01T01:18:03.808Z',
        age: 8,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Sophie',
        last: 'Ford',
      },
      email: 'sophie.ford@example.com',
      registered: {
        date: '2005-09-21T09:56:18.406Z',
        age: 15,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Samuel',
        last: 'Myre',
      },
      email: 'samuel.myre@example.com',
      registered: {
        date: '2005-12-28T22:24:37.644Z',
        age: 15,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Monsieur',
        first: 'José',
        last: 'Bertrand',
      },
      email: 'jose.bertrand@example.com',
      registered: {
        date: '2007-09-07T20:09:22.470Z',
        age: 13,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Adam',
        last: 'Davidson',
      },
      email: 'adam.davidson@example.com',
      registered: {
        date: '2008-02-29T18:59:13.706Z',
        age: 12,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Shania',
        last: 'Brakel',
      },
      email: 'shania.brakel@example.com',
      registered: {
        date: '2017-07-20T19:00:11.213Z',
        age: 3,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Pinja',
        last: 'Moilanen',
      },
      email: 'pinja.moilanen@example.com',
      registered: {
        date: '2002-04-08T14:42:24.215Z',
        age: 18,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Andrea',
        last: 'Møller',
      },
      email: 'andrea.moller@example.com',
      registered: {
        date: '2008-03-20T12:35:00.624Z',
        age: 12,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Mathilde',
        last: 'Thomsen',
      },
      email: 'mathilde.thomsen@example.com',
      registered: {
        date: '2017-03-05T18:09:02.704Z',
        age: 3,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'فاطمه',
        last: 'زارعی',
      },
      email: 'ftmh.zraay@example.com',
      registered: {
        date: '2013-07-07T04:06:30.458Z',
        age: 7,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Kelly',
        last: 'Perry',
      },
      email: 'kelly.perry@example.com',
      registered: {
        date: '2011-04-13T12:00:29.246Z',
        age: 9,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Sofia',
        last: 'Peterson',
      },
      email: 'sofia.peterson@example.com',
      registered: {
        date: '2008-04-07T03:40:44.934Z',
        age: 12,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Silje',
        last: 'Larsen',
      },
      email: 'silje.larsen@example.com',
      registered: {
        date: '2011-09-28T22:40:31.763Z',
        age: 9,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Monsieur',
        first: 'Igor',
        last: 'Bernard',
      },
      email: 'igor.bernard@example.com',
      registered: {
        date: '2016-06-28T19:42:47.930Z',
        age: 4,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Ceyhan',
        last: 'Dalkıran',
      },
      email: 'ceyhan.dalkiran@example.com',
      registered: {
        date: '2010-08-18T18:45:47.970Z',
        age: 10,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Daniel',
        last: 'Perez',
      },
      email: 'daniel.perez@example.com',
      registered: {
        date: '2015-07-25T02:51:05.641Z',
        age: 5,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Hjalmar',
        last: 'Bonsaksen',
      },
      email: 'hjalmar.bonsaksen@example.com',
      registered: {
        date: '2017-12-30T15:53:07.419Z',
        age: 3,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Hilla',
        last: 'Toivonen',
      },
      email: 'hilla.toivonen@example.com',
      registered: {
        date: '2013-06-12T14:11:59.205Z',
        age: 7,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Amanda',
        last: 'Hart',
      },
      email: 'amanda.hart@example.com',
      registered: {
        date: '2019-07-26T14:42:37.865Z',
        age: 1,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Oliver',
        last: 'Poulsen',
      },
      email: 'oliver.poulsen@example.com',
      registered: {
        date: '2018-11-01T01:48:22.609Z',
        age: 2,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Charlotte',
        last: 'Margaret',
      },
      email: 'charlotte.margaret@example.com',
      registered: {
        date: '2004-09-27T21:00:31.128Z',
        age: 16,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Corianne',
        last: 'Kreeft',
      },
      email: 'corianne.kreeft@example.com',
      registered: {
        date: '2017-08-04T10:58:39.574Z',
        age: 3,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Daniel',
        last: 'Lam',
      },
      email: 'daniel.lam@example.com',
      registered: {
        date: '2010-05-31T15:14:25.252Z',
        age: 10,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Sebastian',
        last: 'Caballero',
      },
      email: 'sebastian.caballero@example.com',
      registered: {
        date: '2006-03-07T15:03:54.691Z',
        age: 14,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Cesar',
        last: 'Navarro',
      },
      email: 'cesar.navarro@example.com',
      registered: {
        date: '2005-09-12T11:29:25.424Z',
        age: 15,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Jesus',
        last: 'Fernandez',
      },
      email: 'jesus.fernandez@example.com',
      registered: {
        date: '2003-07-04T13:36:53.832Z',
        age: 17,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Doetje',
        last: 'Knipscheer',
      },
      email: 'doetje.knipscheer@example.com',
      registered: {
        date: '2018-12-12T11:37:42.933Z',
        age: 2,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Ronnie',
        last: 'Adams',
      },
      email: 'ronnie.adams@example.com',
      registered: {
        date: '2013-04-28T02:27:37.747Z',
        age: 7,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Purificacion',
        last: 'Vicente',
      },
      email: 'purificacion.vicente@example.com',
      registered: {
        date: '2014-12-24T16:25:27.743Z',
        age: 6,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Miguel',
        last: 'Gutierrez',
      },
      email: 'miguel.gutierrez@example.com',
      registered: {
        date: '2010-04-08T11:43:27.301Z',
        age: 10,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'محمدپارسا',
        last: 'محمدخان',
      },
      email: 'mhmdprs.mhmdkhn@example.com',
      registered: {
        date: '2012-12-20T22:10:50.892Z',
        age: 8,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Babür',
        last: 'Özdoğan',
      },
      email: 'babur.ozdogan@example.com',
      registered: {
        date: '2013-08-07T16:56:06.387Z',
        age: 7,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Monsieur',
        first: 'Jamie',
        last: 'Carpentier',
      },
      email: 'jamie.carpentier@example.com',
      registered: {
        date: '2005-01-23T10:01:39.882Z',
        age: 15,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Oliver',
        last: 'Poulsen',
      },
      email: 'oliver.poulsen@example.com',
      registered: {
        date: '2014-05-09T21:35:29.848Z',
        age: 6,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Mason',
        last: 'Martin',
      },
      email: 'mason.martin@example.com',
      registered: {
        date: '2017-05-10T03:36:35.818Z',
        age: 3,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Hazel',
        last: 'Perez',
      },
      email: 'hazel.perez@example.com',
      registered: {
        date: '2004-10-26T16:35:58.423Z',
        age: 16,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Phillip',
        last: 'Mitchelle',
      },
      email: 'phillip.mitchelle@example.com',
      registered: {
        date: '2018-11-06T04:42:39.168Z',
        age: 2,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Matilda',
        last: 'Kokko',
      },
      email: 'matilda.kokko@example.com',
      registered: {
        date: '2004-02-22T14:00:10.629Z',
        age: 16,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Jose',
        last: 'Gilbert',
      },
      email: 'jose.gilbert@example.com',
      registered: {
        date: '2013-12-11T15:00:52.790Z',
        age: 7,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Ellen',
        last: 'Mitchelle',
      },
      email: 'ellen.mitchelle@example.com',
      registered: {
        date: '2007-02-09T00:59:48.962Z',
        age: 13,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Afet',
        last: 'Ayaydın',
      },
      email: 'afet.ayaydin@example.com',
      registered: {
        date: '2006-12-17T13:02:36.982Z',
        age: 14,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Faith',
        last: 'Daniels',
      },
      email: 'faith.daniels@example.com',
      registered: {
        date: '2008-02-27T16:06:34.604Z',
        age: 12,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'پرنیا',
        last: 'مرادی',
      },
      email: 'prny.mrdy@example.com',
      registered: {
        date: '2006-09-16T22:10:52.526Z',
        age: 14,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Monsieur',
        first: 'Willy',
        last: 'Le Gall',
      },
      email: 'willy.legall@example.com',
      registered: {
        date: '2009-03-15T15:42:38.252Z',
        age: 11,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Sanni',
        last: 'Kivela',
      },
      email: 'sanni.kivela@example.com',
      registered: {
        date: '2014-03-26T18:10:25.529Z',
        age: 6,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Gabriel',
        last: 'Blanchard',
      },
      email: 'gabriel.blanchard@example.com',
      registered: {
        date: '2003-03-24T15:43:33.133Z',
        age: 17,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Elis',
        last: 'Aragão',
      },
      email: 'elis.aragao@example.com',
      registered: {
        date: '2019-01-10T08:29:39.660Z',
        age: 1,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Floyd',
        last: 'Brewer',
      },
      email: 'floyd.brewer@example.com',
      registered: {
        date: '2003-05-09T01:11:13.332Z',
        age: 17,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Marcus',
        last: 'Thomas',
      },
      email: 'marcus.thomas@example.com',
      registered: {
        date: '2016-09-25T03:36:19.774Z',
        age: 4,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Adam',
        last: 'Olsen',
      },
      email: 'adam.olsen@example.com',
      registered: {
        date: '2004-03-29T23:02:25.128Z',
        age: 16,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Zackary',
        last: 'Thompson',
      },
      email: 'zackary.thompson@example.com',
      registered: {
        date: '2006-07-13T05:48:48.454Z',
        age: 14,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Rose',
        last: 'Hicks',
      },
      email: 'rose.hicks@example.com',
      registered: {
        date: '2009-04-03T10:54:28.246Z',
        age: 11,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Önal',
        last: 'Adan',
      },
      email: 'onal.adan@example.com',
      registered: {
        date: '2012-11-07T20:38:54.676Z',
        age: 8,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Rosario',
        last: 'Marin',
      },
      email: 'rosario.marin@example.com',
      registered: {
        date: '2010-03-06T07:40:22.451Z',
        age: 10,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Maxime',
        last: 'Gauthier',
      },
      email: 'maxime.gauthier@example.com',
      registered: {
        date: '2013-11-08T19:56:56.223Z',
        age: 7,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Oskari',
        last: 'Wainio',
      },
      email: 'oskari.wainio@example.com',
      registered: {
        date: '2016-10-18T06:33:30.136Z',
        age: 4,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Francisco',
        last: 'Pascual',
      },
      email: 'francisco.pascual@example.com',
      registered: {
        date: '2002-07-20T22:40:16.446Z',
        age: 18,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Meral',
        last: 'Dalkıran',
      },
      email: 'meral.dalkiran@example.com',
      registered: {
        date: '2004-07-23T08:58:37.202Z',
        age: 16,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Madeleine',
        last: 'Wang',
      },
      email: 'madeleine.wang@example.com',
      registered: {
        date: '2005-02-17T06:56:41.037Z',
        age: 15,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Nina',
        last: 'Tucker',
      },
      email: 'nina.tucker@example.com',
      registered: {
        date: '2015-02-09T03:59:13.263Z',
        age: 5,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Clarisse',
        last: 'Gonzalez',
      },
      email: 'clarisse.gonzalez@example.com',
      registered: {
        date: '2002-05-20T21:43:55.429Z',
        age: 18,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'بردیا',
        last: 'کریمی',
      },
      email: 'brdy.khrymy@example.com',
      registered: {
        date: '2005-01-10T13:10:49.559Z',
        age: 15,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Monsieur',
        first: 'Richard',
        last: 'Roussel',
      },
      email: 'richard.roussel@example.com',
      registered: {
        date: '2017-10-07T03:49:01.132Z',
        age: 3,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Lillian',
        last: 'Gilbert',
      },
      email: 'lillian.gilbert@example.com',
      registered: {
        date: '2016-02-05T01:06:01.768Z',
        age: 4,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Noémie',
        last: 'Bélanger',
      },
      email: 'noemie.belanger@example.com',
      registered: {
        date: '2007-11-05T07:27:49.071Z',
        age: 13,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Sieger',
        last: 'Van de Wege',
      },
      email: 'sieger.vandewege@example.com',
      registered: {
        date: '2008-10-30T20:26:59.373Z',
        age: 12,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Miss',
        first: 'Samira',
        last: 'Lundby',
      },
      email: 'samira.lundby@example.com',
      registered: {
        date: '2002-08-07T12:01:46.466Z',
        age: 18,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Willian',
        last: 'Van Manen',
      },
      email: 'willian.vanmanen@example.com',
      registered: {
        date: '2011-01-01T18:43:11.554Z',
        age: 9,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Ms',
        first: 'Mélody',
        last: 'Adam',
      },
      email: 'melody.adam@example.com',
      registered: {
        date: '2002-03-28T08:08:53.841Z',
        age: 18,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'آدرین',
        last: 'سالاری',
      },
      email: 'adryn.slry@example.com',
      registered: {
        date: '2015-04-10T00:12:18.488Z',
        age: 5,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Hunter',
        last: 'Tremblay',
      },
      email: 'hunter.tremblay@example.com',
      registered: {
        date: '2010-07-19T23:13:41.864Z',
        age: 10,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Rémi',
        last: 'Marchand',
      },
      email: 'remi.marchand@example.com',
      registered: {
        date: '2004-12-17T16:25:53.775Z',
        age: 16,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Mr',
        first: 'Tom',
        last: 'Snyder',
      },
      email: 'tom.snyder@example.com',
      registered: {
        date: '2011-02-10T04:50:59.147Z',
        age: 9,
      },
    },
    {
      gender: 'male',
      name: {
        title: 'Monsieur',
        first: 'Hervé',
        last: 'Legrand',
      },
      email: 'herve.legrand@example.com',
      registered: {
        date: '2009-02-07T02:34:43.519Z',
        age: 11,
      },
    },
    {
      gender: 'female',
      name: {
        title: 'Mrs',
        first: 'Ilka',
        last: 'Conradi',
      },
      email: 'ilka.conradi@example.com',
      registered: {
        date: '2017-11-01T19:38:21.132Z',
        age: 3,
      },
    },
  ],
  info: {
    seed: '2634ddf16169db50',
    results: 100,
    page: 1,
    version: '1.3',
  },
};

export { users };
